<template>
    <Header></Header>

    <div class="container">
        <section class="sign_form_wrap wrap_840">
            <div class="tab_wrap">
                <div :class="[state.step === 0 ? 'active' : '']">
                    <span class="round_num">step 1</span>
                    이용약관동의
                </div>
                <div :class="[state.step === 1 ? 'active' : '']">
                    <span class="round_num">step 2</span>
                    회원가입
                </div>
                <div :class="[state.step === 2 ? 'active' : '']">
                    <span class="round_num">step 3</span>
                    회원가입완료
                </div>
            </div>
            <template v-if="state.step === 0">
                <div class="join sign_form agree_form">
                    <div class="info">회원가입약관 및 개인정보처리방침안내의 내용에 동의하셔야 회원가입 하실 수 있습니다.</div>
                    <ul>
                        <li class="checkbox_wrap">
                            <label for="agree_all">
                                <input
                                    type="checkbox"
                                    name=""
                                    id="agree_all"
                                    :checked="state.isAgreeAll"
                                    @click="
                                        state.isAgreeJoin = !state.isAgreeAll;
                                        state.isAgreeTerms = !state.isAgreeAll;
                                        state.isAgreeAll = !state.isAgreeAll;
                                    "
                                />
                                <em></em>
                                <span>전체 동의</span>
                            </label>
                        </li>
                        <li class="checkbox_wrap">
                            <div class="con_tit">회원가입약관 (필수)</div>
                            <div class="con_desc">
                                <div class="custom_scroll2">
                                    제 1 조 (목적)
                                    <br />
                                    본 약관(이하 "약관")은 '서울특별시립 다시함께상담센터'(이하 "다시함께상담센터")와 회원에 관한 제반사항을 규정함을
                                    목적으로 합니다.
                                    <br />
                                    <br />

                                    제 2 조 (약관의 효력 등)
                                    <br />
                                    ① 약관은 공시하고 상대방이 동의함으로써 효력을 발생합니다. 본 약관의 공시는 '서울특별시립 다시함께상담센터'
                                    홈페이지(http://gamsi.dasi.or.kr/)에 게시하는 방법으로 합니다.
                                    <br />
                                    ② "다시함께상담센터"는 약관의 규제에 관한 법률 등 관련법을 위배하지 않는 범위 내에서 약관을 개정할 수 있습니다.
                                    <br />
                                    ③ "다시함께상담센터"가 약관을 개정할 경우에는 시행일 및 개정사유를 명시하여 "다시함께상담센터" 홈페이지에 시행일
                                    7일전까지 공지합니다.
                                    <br />
                                    ④ 제3항의 방법으로 변경 고지된 약관은 기존의 회원에게도 유효하게 적용됩니다.
                                    <br />
                                    <br />

                                    제 3 조 (약관의 해석 및 관할법원)
                                    <br />
                                    ① 약관에 정하지 아니한 사항과 이 약관의 해석에 관하여는 관계법령 및 상관례에 따릅니다.
                                    <br />
                                    ② 회원과 "다시함께상담센터" 사이에 분쟁이 발생할 경우에 관할 법원은 서울중앙지방법원으로 합니다.
                                    <br />
                                    <br />

                                    제 4 조 (용어의 정의)
                                    <br />
                                    '회원'은 "다시함께상담센터"에 개인정보를 제공하여 회원등록을 한 자로서, "다시함께상담센터"가 제공하는 서비스를
                                    계속적으로 이용할 수 있는 자를 말합니다.
                                    <br />
                                    <br />

                                    제 5 조 (회원 가입 및 자격)
                                    <br />
                                    ① "다시함께상담센터"가 정한 양식에 따라 회원정보를 기입한 후 회원가입을 신청함으로써 회원으로 등록됩니다.
                                    <br />
                                    ② 다음 각 호에 해당하는 경우에 "다시함께상담센터"는 회원 가입을 인정하지 않거나 회원 자격을 박탈할 수 있습니다.
                                    <br />
                                    1. 다른 사람의 명의를 사용하여 가입 신청한 경우
                                    <br />
                                    2. 신청 시 필수 작성 사항을 허위로 기재한 경우
                                    <br />
                                    3. 관계법령의 위반을 목적으로 신청하거나 그러한 행위를 하는 경우
                                    <br />
                                    4. 사회의 안녕질서 또는 미풍양속을 저해할 목적으로 신청하거나 그러한 행위를 하는 경우
                                    <br />
                                    5. 다른 사람의 "다시함께상담센터"의 이용을 방해하거나 그 정보를 도용하는 등 전자거래질서를 위협하는 경우
                                    <br />
                                    ③ "다시함께상담센터"가 회원 자격을 박탈하는 경우에는 회원등록을 말소합니다. 이 경우 회원에게 사전 통지하여 소명할
                                    기회를 부여합니다.
                                    <br />
                                    <br />

                                    제 6 조 (개인정보의 취득 및 이용)
                                    <br />
                                    ① "다시함께상담센터"는 개인정보 보호정책을 제정하여 시행하고, 개인 정보의 취득과 이용, 보호 등에 관한 법률을
                                    준수합니다. 개인정보보호정책은 홈페이지 하단에 상시적으로 게시합니다.
                                    <br />
                                    ② "다시함께상담센터"는 고객이 제공하는 개인정보를 본 서비스 이외의 목적을 위하여 사용할 수 없습니다.
                                    <br />
                                    ③ "다시함께상담센터"는 고객이 제공한 개인정보를 고객의 사전 동의 없이 제 3자에게 제공할 수 없습니다. 단, 다음 각
                                    호에 해당하는 경우에는 예외로 합니다.
                                    <br />
                                    1. 전기통신기본법 등 관계법령에 의하여 국가기관의 요청에 의한 경우
                                    <br />
                                    2. 범죄에 대한 수사상의 목적이 있거나 정보통신윤리위원회의 요청이 있는 경우
                                    <br />
                                    3. 업무상 연락을 위하여 회원의 정보(성명, 주소, 전화번호)를 사용하는 경우
                                    <br />
                                    4. 홍보자료 또는 시장조사를 위하여 필요한 경우로서 특정 고객임을 식별할 수 없는 형태로 제공되는 경우
                                    <br />
                                    <br />

                                    제 7 조 (회원 탈퇴)
                                    <br />
                                    ① 회원은 "다시함께상담센터"에 언제든지 탈퇴를 요청할 수 있으며 "다시함께상담센터"는 즉시 회원탈퇴를 처리합니다.
                                    <br />
                                    ② 회원이 "다시함께상담센터"에서 이용중인 서비스의 만기일이 지나지 않은 경우 "다시함께상담센터"는 탈퇴를 처리하지
                                    않습니다.
                                    <br />
                                    <br />

                                    제 8 조 (회원에 대한 통지)
                                    <br />
                                    ① "다시함께상담센터"가 회원에 대한 통지를 하는 경우, 회원이 "다시함께상담센터"에 제출한 전자우편 주소,
                                    휴대전화번호로 할 수 있습니다.
                                    <br />
                                    ② "다시함께상담센터"는 불특정다수 회원에 대한 통지의 경우 1주일 이상 "다시함께상담센터" 게시판에 게시함으로서 개별
                                    통지에 갈음할 수 있습니다.
                                    <br />
                                    <br />

                                    제 9 조 ("다시함께상담센터"의 의무)
                                    <br />
                                    ① "다시함께상담센터"는 본 약관이 정하는 바에 따라 지속적이고 안정적인 서비스를 제공하는데 최선을 다합니다.
                                    <br />
                                    ② "다시함께상담센터"는 항상 등록자의 정보를 포함한 개인신상정보에 대하여 관리적, 기술적 안전조치를 강구하여
                                    정보보안에 최선을 다합니다.
                                    <br />
                                    ③ "다시함께상담센터"는 공정하고 건전한 운영을 통하여 전자상거래 질서유지에 최선을 다하고 지속적인 연구개발을
                                    통하여 양질의 서비스를 제공함으로써 고객만족을 극대화하여 인터넷 사업 발전에 기여합니다.
                                    <br />
                                    ④ "다시함께상담센터"는 고객으로부터 제기되는 불편사항 및 문제에 대해 정당하다고 판단될 경우 우선적으로 그 문제를
                                    즉시 처리합니다. 단, 신속한 처리가 곤란할 경우, 고객에게 그 사유와 처리일정을 즉시 통보합니다.
                                    <br />
                                    ⑤ "다시함께상담센터"는 소비자 보호단체 및 공공기관의 소비자 보호업무의 추진에 필요한 자료 등의 요구에 적극
                                    협력합니다.
                                    <br />
                                    <br />

                                    제 10 조 (회원의 의무)
                                    <br />
                                    ① ID와 비밀번호에 관한 모든 관리의 책임은 회원에게 있습니다.
                                    <br />
                                    ② 회원은 ID와 비밀번호를 제 3 자가 알 수 있도록 해서는 안 됩니다.
                                    <br />
                                    ③ 회원은 본 약관 및 관계법령에서 규정한 사항을 준수합니다.
                                    <br />
                                </div>
                            </div>
                            <label for="agree_01">
                                <input
                                    type="checkbox"
                                    name=""
                                    id="agree_01"
                                    :checked="state.isAgreeJoin"
                                    @click="state.isAgreeJoin = !state.isAgreeJoin"
                                />
                                <em></em>
                                <span>회원가입약관의 내용에 동의합니다.</span>
                            </label>
                        </li>
                        <li class="checkbox_wrap">
                            <div class="con_tit">개인정보처리방침 안내 (필수)</div>
                            <div class="con_desc">
                                <div class="custom_scroll2">
                                    서울특별시립 다시함께상담센터는 「개인정보보호법」을 준수하며 개인정보 보호에 최선을 다하고 있습니다.
                                    <br />
                                    <br />
                                    서울특별시립 다시함께상담센터는 시민이 필요로 하는 맞춤형 행정정보를 이메일, 휴대폰 문자(SMS) 등을 이용하여 빠르게
                                    전달하고자 최소한의 개인정보를 수집하고 있으며 이를 위하여 ‘개인정보 제공 및 활용에 대한 동의’를 구하고 있습니다.
                                    <br />
                                    <br />
                                    수집된 개인정보는 행사, 이벤트, 생활 정보, 센터 소식, 만족도 조사, 설문조사를 알려드리는 데에만 활용되며 일체 타
                                    업무 목적으로는 활용되지 않습니다. 또한, 체계적이고 안전한 개인정보 보호 및 관리를 약속드립니다.
                                    <br />
                                    <br />
                                    ① 수집목적 : 행사, 이벤트, 생활 정보, 센터 소식, 만족도 조사, 설문조사, 물품 배송 ② 수집내용 : 필수항목(ID, 성명,
                                    연락처, 생년월일, 성별, 주소(우편번호), 이메일주소), 선택항목(직업, 가입경로) ③ 보유기간 : 회원가입 날짜로부터
                                    2년(단, 개인정보 삭제 요청 시 즉시 삭제)
                                    <br />
                                    <br />
                                    서울특별시립 다시함께상담센터
                                </div>
                            </div>
                            <label for="agree_02">
                                <input
                                    type="checkbox"
                                    name=""
                                    id="agree_02"
                                    :checked="state.isAgreeTerms"
                                    @click="state.isAgreeTerms = !state.isAgreeTerms"
                                />
                                <em></em>
                                <span>개인정보처리방침 안내 내용에 동의합니다.</span>
                            </label>
                        </li>
                    </ul>
                    <div class="btn_wrap _default _250">
                        <button class="submit_btn" @click="moveStep(1)">다음</button>
                    </div>
                </div>
            </template>
            <template v-else-if="state.step === 1">
                <div class="join sign_form">
                    <ul>
                        <li class="imp">
                            <label for="user_id" class="form_li_tit">아이디</label>
                            <input id="user_id" type="text" v-model="form_state.id" placeholder="아이디를 입력하세요" />
                            <button class="blue_btn" @click="idExist">중복확인</button>
                            <!-- <button class="blue_btn _blocked">확인완료</button> -->
                            <p class="p_info" v-if="!state.idIsPossible">영문자, 숫자, _만 입력 가능/ 최소 6자 이상 12자 이하로 입력하세요</p>
                        </li>
                        <template v-if="form_state.snsGubun === 1">
                            <li class="imp">
                                <label for="user_pw" class="form_li_tit">비밀번호</label>
                                <input id="user_pw" type="password" v-model="state.pw" placeholder="비밀번호를 입력하세요" />
                                <p class="p_info" v-if="!state.pwIsPossible">비밀번호는 문자, 숫자, 특수문자의 조합으로 8자 이상 입력해주세요.</p>
                            </li>
                            <li class="imp">
                                <label for="user_pw_chk" class="form_li_tit">비밀번호 확인</label>
                                <input id="user_pw_chk" type="password" v-model="state.re_pw" placeholder="비밀번호 확인" />
                                <p class="p_warn" v-if="!state.pwReCheck">*비밀번호가 일치하지 않습니다. 다시 입력해주세요.</p>
                            </li>
                        </template>
                        <li class="imp">
                            <label for="name" class="form_li_tit">이름</label>
                            <input id="name" type="text" v-model="form_state.name" placeholder="이름을 입력하세요" :disabled="state.isPassOk" />
                        </li>
                        <li class="">
                            <label for="nick" class="form_li_tit">닉네임</label>
                            <input id="nick" type="text" v-model="form_state.nickname" placeholder="닉네임을 입력하세요" />
                        </li>
                        <li class="imp">
                            <label for="day" class="form_li_tit">생년월일</label>
                            <input
                                id="day"
                                type="text"
                                v-model="form_state.birth"
                                placeholder="예: 20201212"
                                maxlength="8"
                                :disabled="state.isPassOk"
                            />
                            <p class="p_warn" v-if="!state.birthIsPossible">*생년월일이 올바르지 않습니다.</p>
                        </li>
                        <li class="imp checkbox_wrap">
                            <span class="form_li_tit">성별</span>
                            <template v-for="(item, idx) in gender_list" :key="idx">
                                <label :for="item.id">
                                    <input
                                        :id="item.id"
                                        :value="item.key"
                                        v-model="form_state.gender"
                                        name="gender"
                                        type="radio"
                                        :disabled="state.isPassOk"
                                    />
                                    <em></em>
                                    <span v-text="item.value"></span>
                                </label>
                            </template>
                        </li>
                        <li class="imp mail_wrap">
                            <label for="mail_01" class="form_li_tit">E-mail</label>
                            <input id="mail_01" type="text" v-model="state.email" placeholder="" />
                            <em>@</em>
                            <input id="mail_02" type="text" v-model="state.email_domain" placeholder="" />
                            <div class="select_tab_box">
                                <div class="selected_tab" :class="[state.isActive ? 'active' : '']" @click="state.isActive = !state.isActive">
                                    <span>{{ state.select_domain }}</span>
                                </div>
                                <div class="tab_option">
                                    <button
                                        v-for="(value, idx) in email_domain_list"
                                        :key="idx"
                                        @click="
                                            state.email_domain = value;
                                            state.isActive = false;
                                            state.select_domain = value;
                                        "
                                        :class="[state.email_domain === value ? 'active' : '']"
                                    >
                                        {{ value }}
                                    </button>

                                    <button
                                        class="self"
                                        @click="
                                            state.email_domain = '';
                                            state.isActive = false;
                                            state.select_domain = '직접입력';
                                        "
                                    >
                                        직접입력
                                    </button>
                                </div>
                            </div>
                            <button class="blue_btn" @click="emailExist(form_state.email)">중복확인</button>
                            <!-- <button class="blue_btn _blocked">확인완료</button> -->
                        </li>
                        <li class="imp phone_wrap">
                            <label for="user_ph1" class="form_li_tit">전화번호</label>
                            <input id="user_ph1" v-model="state.phone1" type="text" maxlength="3" :disabled="state.isPassOk" />
                            <em>-</em>
                            <input id="user_ph2" v-model="state.phone2" type="text" maxlength="4" :disabled="state.isPassOk" />
                            <em>-</em>
                            <input id="user_ph3" v-model="state.phone3" type="text" maxlength="4" :disabled="state.isPassOk" />
                        </li>
                        <li class="imp add_wrap">
                            <label for="zipCode" class="form_li_tit">주소</label>
                            <input
                                id="zipCode"
                                type="text"
                                v-model="form_state.zip_code"
                                readonly
                                class="code"
                                placeholder="우편번호"
                                @click="searchAddress"
                            />
                            <button id="btnSearch" class="blue_btn" @click="searchAddress">검색</button>
                            <input id="address" type="text" v-model="form_state.address" readonly class="main_add" placeholder="기본주소" />
                            <input id="address_detail" type="text" v-model="form_state.address_detail" placeholder="상세주소" />
                        </li>
                        <li class="join_way_wrap checkbox_wrap">
                            <span class="form_li_tit _full">가입경로</span>
                            <label v-for="item in location_list" :key="item.key" :for="'join_way' + item.key">
                                <input
                                    :id="'join_way' + item.key"
                                    name="join_way"
                                    type="radio"
                                    :value="item.key"
                                    v-model="form_state.location"
                                    @click="toggleRadio(item.key)"
                                />
                                <em></em>
                                <span v-text="item.value"></span>

                                <template v-if="item.key === 5 && form_state.location === item.key">
                                    <input type="text" v-model="form_state.location_detail" placeholder="예: 커뮤니티, 대학교 게시판" />
                                </template>
                            </label>
                        </li>
                        <li class="checkbox_wrap">
                            <span class="form_li_tit _full">원활한 활동 소식 안내를 위해 정보제공 수신 동의 부탁드립니다.</span>
                            <label for="agree">
                                <input id="agree" type="checkbox" @click="state.is_supply = !state.is_supply" />
                                <em></em>
                                <span class="no_blue">정보 메일을 받겠습니다. [선택]</span>
                            </label>
                        </li>
                    </ul>
                    <div class="btn_wrap _default _500">
                        <button class="submit_btn _gray" @click="state.step = 0">취소</button>
                        <button class="submit_btn" :disabled="!state.isPossible" @click="join">회원가입</button>

                        <!-- 버튼 -->
                        <!-- <button @click="openModal">서명하기</button> -->
                    </div>
                </div>
            </template>
            <template v-else-if="state.step === 2">
                <div class="result_wrap wrap_500 join">
                    <div class="deco_wrap">
                        <span class="icon_wrap"><img src="img/chk_big.png" alt="" /></span>
                        <div class="main_bg_wrap">
                            <i class="deco_01 _small _blue"><img src="img/bg_deco_03.png" alt="" /></i>
                            <i class="deco_02 _small"><img src="img/bg_deco_01.png" alt="" /></i>
                            <i class="deco_03 _small _green"><img src="img/bg_deco_01.png" alt="" /></i>
                            <i class="deco_04 _small _green"><img src="img/bg_deco_01.png" alt="" /></i>
                            <i class="deco_05 _small"><img src="img/bg_deco_02.png" alt="" /></i>
                            <i class="deco_06 _small"><img src="img/bg_deco_02.png" alt="" /></i>
                        </div>
                    </div>
                    <div class="con_wrap">
                        <p class="con_tit">회원가입이 완료되었습니다.</p>
                        <p>
                            반성매매 시민참여 플랫폼에서 진행하는
                            <br />
                            다양한 활동을 확인해보세요.
                        </p>
                    </div>
                </div>
                <div class="btn_wrap _default wrap_500">
                    <button class="submit_btn" @click="router.replace('/')">홈으로</button>
                </div>
            </template>
        </section>
    </div>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
    <!-- <Sign :config="config" @saved="handleSave" @close="closeModal" /> -->
    <Footer></Footer>
</template>

<script lang="ts" config>
    import {
        reactive,
        router,
        apiService,
        onMounted,
        Footer,
        Header,
        types,
        watch,
        computed,
        Sign,
        globalStore,
        CommonUtils,
        ModalDefault,
        getMessageByCode,
        onBeforeUnmount,
    } from "@/BaseComponent";

    export default {
        props: {
            imgUrl: String,
        },
        components: { Header, Footer, Sign, ModalDefault },
        setup() {
            const global = globalStore();
            const email_domain_list = ["naver.com", "gmail.com", "daum.net"];
            const gender_list = [
                { id: "femail", key: "F", value: "여자" },
                { id: "mail", key: "M", value: "남자" },
                { id: "gender_etc", key: "E", value: "기타" },
            ];
            const location_list = [
                { key: 1, value: "다시함께상담센터 홈페이지" },
                { key: 2, value: "포털사이트 검색(네이버,구글 등)" },
                { key: 3, value: "SNS(X (구.트위터), 인스타그램 등)" },
                { key: 4, value: "지인추천" },
                { key: 5, value: "기타" },
            ];
            const state = reactive({
                pw: "",
                re_pw: "",
                isActive: false,
                isPossible: false,
                idIsPossible: false,
                pwIsPossible: false,
                pwReCheck: false,
                emailIsPossible: false,
                phoneIsPossible: false,
                birthIsPossible: false,
                email: "",
                email_domain: "",
                phone1: "",
                phone2: "",
                phone3: "",
                select_domain: "직접입력",
                is_supply: false,
                step: 0 as number,
                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                isAgreeAll: false as boolean,
                isAgreeJoin: false as boolean,
                isAgreeTerms: false as boolean,

                isPassOk: false as boolean,

                isIdChecked: false as boolean,
                isEmailChecked: false as boolean,
            });
            const form_state = reactive({
                id: "",
                pw: "",
                name: "",
                nickname: "",
                birth: "",
                gender: "",
                email: "",
                phone: "",
                zip_code: "",
                address: "",
                address_detail: "",
                location: 0,
                location_detail: "",
                isSupply: state.is_supply ? 1 : 0,
                sign_file: "",
                snsGubun: 0 as number,
                requestNo: "" as string | null,
            });

            const config = reactive({
                visible: false,
                width: 600,
                height: 400,
                penColor: "black",
                backgroundColor: "white",
            });

            onMounted(() => {
                // TODO :: yn
                state.step = 0;
                state.isPassOk = false;
                if (global.snsInfo && global.snsInfo.birth !== undefined) {
                    form_state.birth = global.snsInfo.birth;
                    state.email = global.snsInfo.email?.split("@")[0];
                    state.email_domain = global.snsInfo.email?.split("@")[1];
                    state.select_domain = global.snsInfo.email?.split("@")[1];
                    form_state.name = global.snsInfo.name;
                    state.phone1 = global.snsInfo.phoneNum?.substr(0, 3);
                    state.phone2 = global.snsInfo.phoneNum?.substr(3, 4);
                    state.phone3 = global.snsInfo.phoneNum?.substr(7, 4);
                    form_state.snsGubun = global.snsInfo.snsType === "naver" ? 3 : 2;
                } else {
                    form_state.snsGubun = 1;
                }
            });

            onBeforeUnmount(() => {
                global.setSnsInfo(null);
            });

            watch(
                () => form_state.id,
                () => {
                    state.isPossible = false;
                    state.isIdChecked = false;

                    if (CommonUtils.regexForId.test(form_state.id)) state.idIsPossible = true;
                    else state.idIsPossible = false;
                },
            );

            watch(
                () => state.pw,
                () => {
                    if (CommonUtils.regexForPassword.test(state.pw)) state.pwIsPossible = true;
                    else state.pwIsPossible = false;
                },
            );

            watch(
                () => [state.isAgreeJoin, state.isAgreeTerms],
                () => {
                    if (!state.isAgreeJoin || !state.isAgreeTerms) {
                        state.isAgreeAll = false;
                    } else if (state.isAgreeJoin && state.isAgreeTerms) {
                        state.isAgreeAll = true;
                    }
                },
            );

            watch(
                () => [state.email, state.email_domain],
                () => {
                    state.isEmailChecked = false;

                    if (CommonUtils.regexForEmail.test(state.email + "@" + state.email_domain)) {
                        state.emailIsPossible = true;
                        form_state.email = state.email + "@" + state.email_domain;
                    } else {
                        state.emailIsPossible = false;
                        form_state.email = "";
                    }
                },
            );

            watch(
                () => [state.pw, state.re_pw],
                () => {
                    if (state.pw === state.re_pw) {
                        state.pwReCheck = true;
                        form_state.pw = state.pw;
                    } else {
                        state.pwReCheck = false;
                        form_state.pw = "";
                    }
                },
            );

            watch(
                () => [state.phone1, state.phone2, state.phone3],
                () => {
                    if (CommonUtils.regexForPhone.test(state.phone1 + "-" + state.phone2 + "-" + state.phone3)) {
                        state.phoneIsPossible = true;
                        form_state.phone = state.phone1 + state.phone2 + state.phone3;
                    } else {
                        state.phoneIsPossible = false;
                        form_state.phone = "";
                    }
                },
            );

            watch(
                () => form_state.birth,
                () => {
                    if (CommonUtils.isValidDate(form_state.birth)) state.birthIsPossible = true;
                    else state.birthIsPossible = false;
                },
            );

            watch(form_state, () => {
                requiredValueCheck();
            });

            const idExist = async () => {
                if (!form_state.id) {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "id를 입력해주세요.";
                    state.isShowModal = true;
                } else if (!CommonUtils.regexForId.test(form_state.id)) {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "id가 올바르지 않습니다.";
                    state.isShowModal = true;
                } else {
                    let res: types.BaseResponse = await apiService.base.idExist(form_state.id);
                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "안내";
                        state.modalContent = "사용 가능합니다.";
                        state.isShowModal = true;
                        state.idIsPossible = true;
                        state.isIdChecked = true;
                        requiredValueCheck();
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                }
            };

            const emailExist = async (email: string) => {
                if (!email) {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "이메일이 올바르지 않습니다.";
                    state.isShowModal = true;
                    return;
                }

                state.emailIsPossible = false;
                const res = await apiService.base.emailExist(email);
                if (res.returnCode === 0) {
                    state.emailIsPossible = true;
                    state.isEmailChecked = true;
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "사용 가능합니다.";
                    state.isShowModal = true;
                    requiredValueCheck();
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const requiredValueCheck = () => {
                state.isPossible = false;

                if (!state.idIsPossible) return;
                if (form_state.snsGubun === 1 && !state.pwIsPossible) return;
                if (!state.emailIsPossible) return;
                if (!state.phoneIsPossible) return;
                if (!state.birthIsPossible) return;

                if (!state.isIdChecked) return;
                if (!state.isEmailChecked) return;

                if (!form_state.id?.trim()) return;
                if (form_state.snsGubun === 1 && !form_state.pw?.trim()) return;
                if (!form_state.name?.trim()) return;
                if (!form_state.birth?.trim()) return;
                if (!form_state.gender?.trim()) return;
                if (!form_state.email?.trim()) return;
                if (!form_state.phone?.trim()) return;
                if (!form_state.zip_code?.trim()) return;
                if (!form_state.address?.trim()) return;
                if (!form_state.address_detail?.trim()) return;
                if (form_state.location === 5 && !form_state.location_detail?.trim()) return;

                state.isPossible = true;
            };

            const join = async () => {
                if (state.isPossible) {
                    const param: types.ReqUserForJoin = {
                        id: form_state.id,
                        name: form_state.name,
                        nickname: form_state.nickname,
                        birthDay: form_state.birth,
                        gender: form_state.gender,
                        signFile: form_state.sign_file,
                        certificate: state.isPassOk ? 1 : 0,
                        location: form_state.location,
                        locationDetail: form_state.location_detail,
                        isSupply: form_state.isSupply,
                        pw: form_state.pw,
                        email: form_state.email,
                        phone: form_state.phone,
                        zipCode: form_state.zip_code,
                        address: form_state.address,
                        addressDetail: form_state.address_detail,
                        job: "",
                        snsGubun: form_state.snsGubun,
                        requestNo: form_state.requestNo,
                    };
                    let res: types.BaseResponse = await apiService.base.join(param);
                    if (res.returnCode === 0) {
                        moveStep(2);
                        global.setSnsInfo(null);
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                }
            };

            const moveStep = (step: number) => {
                let nextFlag: boolean = false;
                switch (step) {
                    case 1:
                        {
                            if (state.isAgreeJoin && state.isAgreeTerms) {
                                nextFlag = true;
                            } else {
                                state.modalTab = -1;
                                state.modalTitle = "알림";
                                state.modalContent = "약관에 동의해주세요.";
                                state.isShowModal = true;
                            }
                        }
                        break;
                    case 2:
                        nextFlag = true;
                        break;
                }

                if (step === 1) {
                    if (global.snsInfo && global.snsInfo.birth !== undefined) {
                        if (nextFlag) state.step = step;
                    } else {
                        if (nextFlag) passCertificate();
                    }
                } else {
                    if (nextFlag) state.step = step;
                }
            };

            const searchAddress = async () => {
                new window.daum.Postcode({
                    oncomplete: (data: any) => {
                        form_state.zip_code = data.zonecode; // 우편번호
                        form_state.address = data.address; // 전체 주소
                    },
                }).open();
            };

            const openModal = () => {
                config.visible = true;
            };

            const closeModal = () => {
                config.visible = false;
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {};

            const toggleRadio = (param: number) => {
                form_state.location = form_state.location === param ? 0 : param;
            };

            const passCertificate = async () => {
                const url = process.env.VUE_APP_SNS_LOGIN_URI + `/auth/niceApi/certificate`;
                const popupOption = "width=500,height=600,top=100,left=100,menubar=no,toolbar=no,location=no,status=no";
                const passWindow = window.open(url, "_blank", popupOption);

                window.removeEventListener("message", receiveMessage);
                window.addEventListener("message", (event) => receiveMessage(event), { once: true });
            };

            const receiveMessage = async (event: any) => {
                if (!event.origin || !event.origin.includes(process.env.VUE_APP_BACK_DOMAIN)) return;

                const { name, phone, birthDate, gender, requestNo } = event.data;

                if (name && phone && birthDate && gender && requestNo) {
                    state.phone1 = phone.substr(0, 3);
                    state.phone2 = phone.substr(3, 4);
                    state.phone3 = phone.substr(7, 4);

                    form_state.name = name;
                    form_state.phone = phone;
                    form_state.gender = gender === "1" ? "M" : "F";
                    form_state.birth = birthDate;
                    form_state.requestNo = requestNo;

                    state.step = 1;
                    state.isPassOk = true;
                }

                window.removeEventListener("message", receiveMessage);
            };

            return {
                state,
                form_state,
                email_domain_list,
                gender_list,
                location_list,
                idExist,
                emailExist,
                searchAddress,
                join,
                config,
                openModal,
                closeModal,

                moveStep,
                router,
                global,
                callBackModal,
                toggleRadio,
            };
        },
    };
</script>
<style scoped>
    input[readonly] {
        background-color: #f5f5f5;
    }
</style>
